import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react'
import { WasteStreamAgreement } from 'pages/Settings/WasteAdministration/WasteStreamAgreements/types'
import { INITIAL_AGREEMENTS } from 'pages/Settings/WasteAdministration/WasteStreamAgreements/constants'

interface DummyClientsMockDataContextType {
  features: {
    wasteStreamAgreements: {
      data: WasteStreamAgreement[]
      setData: React.Dispatch<React.SetStateAction<WasteStreamAgreement[]>>
    }
    wasteTransferDetails: {
      data: Record<string, any>
      setData: React.Dispatch<React.SetStateAction<Record<string, any>>>
    }
  }
}

const DummyClientsMockDataContext = createContext<DummyClientsMockDataContextType | undefined>(
  undefined,
)

export const DummyClientsMockDataProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [wasteStreamAgreements, setWasteStreamAgreements] = useState<WasteStreamAgreement[]>(() => {
    const stored = localStorage.getItem('mockWasteStreamAgreements')
    return stored ? JSON.parse(stored) : INITIAL_AGREEMENTS
  })

  const [wasteTransferDetails, setWasteTransferDetails] = useState<Record<string, any>>(() => {
    const stored = localStorage.getItem('mockWasteTransferDetails')
    return stored ? JSON.parse(stored) : {}
  })

  useEffect(() => {
    localStorage.setItem('mockWasteStreamAgreements', JSON.stringify(wasteStreamAgreements))
  }, [wasteStreamAgreements])

  useEffect(() => {
    localStorage.setItem('mockWasteTransferDetails', JSON.stringify(wasteTransferDetails))
  }, [wasteTransferDetails])

  const value = {
    features: {
      wasteStreamAgreements: {
        data: wasteStreamAgreements,
        setData: setWasteStreamAgreements,
      },
      wasteTransferDetails: {
        data: wasteTransferDetails,
        setData: setWasteTransferDetails,
      },
    },
  }

  return (
    <DummyClientsMockDataContext.Provider value={value}>
      {children}
    </DummyClientsMockDataContext.Provider>
  )
}

export const useDummyClientsMockData = () => {
  const context = useContext(DummyClientsMockDataContext)
  if (context === undefined) {
    throw new Error('useDummyClientsMockData must be used within a DummyClientsMockDataProvider')
  }
  return context
}
